import * as EasyPieChart from 'easy-pie-chart';
import Highcharts from 'highcharts';
import heatmap from 'highcharts/modules/heatmap';
import boost from 'highcharts/modules/boost';
import customEvents from 'highcharts-custom-events';
import more from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import varyWide from 'highcharts/modules/variwide';
import groupedCategories from 'highcharts-grouped-categories';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import offlineExporting from 'highcharts/modules/offline-exporting';

more(Highcharts);
heatmap(Highcharts);
boost(Highcharts);
customEvents(Highcharts);
solidGauge(Highcharts);
varyWide(Highcharts);
groupedCategories(Highcharts);
exporting(Highcharts);
exportData(Highcharts);
offlineExporting(Highcharts);

Highcharts.setOptions({
    exporting: {
        chartOptions: {
            title: null
        },
        buttons: {
            contextButton: {
                menuItems: ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadSVG']
            }
        }
    }
});

(window as unknown as { Highcharts: typeof Highcharts }).Highcharts = Highcharts;
(window as unknown as { EasyPieChart: typeof EasyPieChart }).EasyPieChart = EasyPieChart;

(window as unknown as { HFinfo: { version: string; date: string } }).HFinfo = {
    version: '/*@@srcVersion@@*/',
    date: '/*@@srcDate@@*/'
};
